import styled from '@emotion/styled';
import { Text } from '~/shared/components/Text';
import { ButtonLegacy } from '~/shared/components/_Button';

export const StyledReserveStockCountWrapper = styled.div({
    display: 'flex',
    justifyContent: 'space-between',
});

export const StyledReserveStockCountText = styled(Text)(({ theme }) => ({
    fontWeight: theme.fontWeights.medium,
    minHeight: theme.fontSizes.sm,

    b: {
        fontWeight: theme.fontWeights.bold,
    },
}));

export const StyledReserveStockCountButton = styled(ButtonLegacy)(({ theme }) => ({
    fontWeight: theme.fontWeights.medium,
    paddingTop: 0,
}));
